module.exports = __webpack_public_path__ + "media/images/wedding/thumb/25-b23bec441b7573b8371e37c2579c129d.jpg";